import { FiKey, FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { ApiKeysPanel } from './ApiKeysPanel';

export function ApiKeysModal({ open, onClose }) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[145] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4">
      <div className="w-full max-w-6xl max-h-[85vh] rounded-[28px] border border-white/10 bg-gradient-to-br from-surface/95 via-surface to-surface-highlight/70 shadow-[0_40px_120px_rgba(2,6,23,0.65)] ring-1 ring-white/5 flex flex-col">
        <div className="flex items-start justify-between gap-4 px-7 py-6 border-b border-white/5 bg-gradient-to-r from-white/5 via-transparent to-transparent shrink-0">
          <div className="flex items-start gap-3">
            <div className="h-11 w-11 rounded-2xl bg-violet-500/10 border border-violet-400/20 flex items-center justify-center">
              <FiKey className="text-violet-300" />
            </div>
            <div>
              <div className="text-[11px] uppercase tracking-[0.35em] text-slate-500">
                {t('account.apiKeys.eyebrow')}
              </div>
              <div className="mt-2 text-2xl font-semibold text-white">
                {t('account.apiKeys.title')}
              </div>
              <p className="mt-2 text-sm text-slate-400">
                {t('account.apiKeys.description')}
              </p>
            </div>
          </div>

          <button
            className="rounded-full border border-white/10 bg-white/5 p-2 text-slate-300 hover:text-white hover:bg-white/10 transition-colors"
            onClick={onClose}
            type="button"
          >
            <FiX size={16} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-7 py-6">
          <ApiKeysPanel active={open} showHeader={false} />
        </div>
      </div>
    </div>
  );
}
